export class RedDot {
    constructor() {
        this.animating = false;
        this.isOverContent = true;
        //Mouse offset
        this.OX = -30;
        this.OY = -30;
        //dot coordinates
        this.x = -1;
        this.y = -1;
        //dot scale
        this.scale = 0;
        //previous coordinate values
        this.prevX = -1;
        this.prevY = -1;
        this.scrollSpeed = 0;
        //helpers for killing scrollspeed when idling
        this.prevScrollSpeed = 0;
        this.scrollResetCounter = 0;
        this.dot = document.createElement("span");
        //this.dot.classList.add("bg-brand-red", "w-xs", "h-xs", "fixed", "top-0", "left-0", "rounded-full", "transition-dot", "duration-300", "ease-button", "origin-center", "hide-on-keyboard", "hide-on-touch");
        document.body.appendChild(this.dot);
        const content = document.querySelector("#content");
        if (content) {
            content.addEventListener("mousemove", (e) => this.onMouseMove(e));
            content.addEventListener("mouseout", (e) => this.onMouseOut(e));
            content.addEventListener("mouseover", (e) => this.onMouseOver(e));
        }
        document.addEventListener("scroll", (e) => this.onScroll(e));
    }
    get _x() {
        return this.x;
    }
    get _ox() {
        return this.OX;
    }
    get _y() {
        return this.y;
    }
    get _oy() {
        return this.OY;
    }
    onScroll(e) {
        if (this.prevScrollY === undefined) {
            this.scrollSpeed = 0;
        }
        else {
            const change = this.prevScrollY - window.scrollY;
            if (change > 0) {
                this.scrollSpeed = Math.min(100, change) * 0.01;
            }
            else {
                this.scrollSpeed = Math.max(-100, change) * 0.01;
            }
        }
        this.prevScrollY = window.scrollY;
        if (!this.animating && this.mx !== undefined) {
            this.animating = true;
            this.onUpdate();
        }
    }
    onMouseOver(e) {
        this.isOverContent = true;
        this.show();
    }
    onMouseOut(e) {
        this.isOverContent = false;
        this.hide();
    }
    onMouseMove(e) {
        if (this.x == -1 && this.y == -1) {
            this.x = e.clientX;
            this.y = e.clientY;
        }
        this.mx = e.clientX;
        this.my = e.clientY;
        if (!this.animating) {
            this.animating = true;
            this.onUpdate();
        }
    }
    hide() {
        this.isOverContent = false;
    }
    show() {
        this.isOverContent = true;
    }
    onUpdate() {
        this.x = this.lerp(this.x, this.mx, 0.2);
        let xChanged = this.x != this.prevX;
        if (xChanged) {
            this.prevX = this.x;
        }
        if (Math.abs(this.scrollSpeed) < 0.04) {
            this.scrollSpeed = 0;
        }
        if (this.scrollSpeed == this.prevScrollSpeed) {
            if (this.scrollResetCounter++ > 7) {
                this.prevScrollSpeed = this.scrollResetCounter = this.scrollSpeed = 0;
            }
        }
        this.prevScrollSpeed = this.scrollSpeed;
        this.y = this.lerp(this.y, this.my, 0.2) + this.scrollSpeed * 15;
        let yChanged = this.y != this.prevY;
        if (yChanged) {
            this.prevY = this.y;
        }
        const targetX = this.x + this.OX;
        const targetY = this.y + this.OY;
        let targetOpa = "";
        if (this.isOverContent) {
            this.scale = this.lerp(this.scale, 1, 0.2);
        }
        else {
            this.scale = this.lerp(this.scale, 0, 0.2);
            if (this.scale < 0.001) {
                this.scale = 0;
            }
            targetOpa = "0";
        }
        this.dot.style.transform = "translate(" + targetX + "px, " + targetY + "px) scale(" + this.scale + ")";
        if (targetOpa) {
            this.dot.style.opacity = targetOpa;
        }
        if (xChanged || yChanged || this.scrollSpeed != 0) {
            window.requestAnimationFrame(() => this.onUpdate());
        }
        else {
            this.animating = false;
        }
    }
    lerp(start, end, amt) {
        return Number.parseFloat(((1 - amt) * start + amt * end).toFixed(5));
    }
}
